module.exports = __webpack_public_path__ + "img/buying.f0bb6f50.svg";